module.exports = __webpack_public_path__ + "img/parachute.a39c9a8e.svg";